import React, {useState} from 'react';
import {Container, NavDropdown, Nav, Navbar, Form, FormControl,Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"
const Subscribe = () => {
    const [Notify, SetNotify] = useState("")

const SubscribeFunction= () =>{
    var name = document.getElementById("fullnamenewsletter").value 
    var email = document.getElementById("newsletteremail").value 
    console.log(name)
    console.log(email)
if (name ===""){
    SetNotify("Input your name")
}

else if (email ===""){
    SetNotify("Input your email")
}

else{
    var settingsone = {
        beforeSend: function(){
            SetNotify("Subscribing...")
        },
        "url": "https://vast-bastion-98389.herokuapp.com/https://accounts.zoho.com/oauth/v2/token?refresh_token=1000.7e5557a26c308db2baae36c42c2cf4f3.2b156822d3e41c6e3d6f124374942133&client_id=1000.E7OTJTJ41R7DFO8E5011SHAWXQY4ZZ&client_secret=26b56a2da58cb14f1a55fc9a3931689764ccb3a25a&grant_type=refresh_token",
        "method": "POST",
        "timeout": 0,
        }
             
        $.ajax(settingsone).done(function (responseone) {
            console.log(responseone)
          console.log(responseone.access_token)

    var settingstwo = {
        beforeSend: function(){
            SetNotify("Processing...")
        },
        "url": "https://api.rich-oak.com/api/generic_links",
        "method": "POST",
        "timeout": 0,
        //    "headers": { "Authorization": `Zoho-oauthtoken ${responseone.access_token}`},
           "data":
         {
             "first_name":name, 
             "contact_email":email, 
             "authorization":`Zoho-oauthtoken ${responseone.access_token}`
          
         },
        }
             
        $.ajax(settingstwo).done(function (responsetwo) {
          console.log(responsetwo)
          SetNotify(`A confirmation email has been sent to ${email}.`)
   
        })
        //   localStorage.setItem("userpin", responsetwo.pin_confirmation_url );

       
   
        })


}
  
}


return(
<div className="whitenewsletterbox">
<h4 className="ap2herotitle">Subscribe to our newsletter
    </h4>
    <p className="newslettersubtext">Enter your first name and email address to receive our latest news, articles<br/>  and updates from Earth VII</p>

    <div class="row">
        <div class="col-md-3">
        </div>
        
        <div class="col-md-6">
<div className="row aptsubinput">
<div class="col-md-6">
            <input type="text" class="form-control form-control-lg" id="fullnamenewsletter" placeholder="Enter Name"/>

            </div>

          
     <div class="col-sm-6 aptemailinput">
                                <div class="single">
                                    <div class="input-group">
                                        <input type="email" class="form-control" placeholder="Enter email Address" id="newsletteremail"/>
                                        <span class="input-group-btn">
                                            <button class="btn btn-theme" type="submit" onClick={SubscribeFunction}>Submit</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
{/* <Nav.Link className="homesheroctabutton "  href="/signup"><button className="hmfirstboxbutton3">Explore apartments</button></Nav.Link> */}
        {/* <Nav.Link className="homesheroctabutton  homesctabutton2"  href="/homes"><p>Contact us  <img className="" src="images/diagonalarrow.png"/></p></Nav.Link> */}
<p style={{textAlign:"center",paddingTop:"20px", color:"#CD3E3E", fontWeight:"bold"}}>{Notify}</p>
</div>
        
        </div>

        <div class="col-md-3">
        </div>
  
    </div>
    </div>

)

};


export default Subscribe;